module.exports = __webpack_public_path__ + "media/images/favicon-f20004b5b90e3b5f7d59902a29cadd7d.jpg";